import { ExerciseAbcBase } from './exerciseAbcBase';

export class ExerciseAbc4 extends ExerciseAbcBase {
  constructor() {
    super('ExerciseAbc4', 4);
  }
}
